module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("64exS"))).then(() => module.bundle.root('cvs7o'));